import { motion } from 'framer-motion'
import { AnimatedGridPattern } from '../ui/animated-grid-pattern'
import { useT } from '../../i18n/LocaleContext'

export default function BlogHero() {
  const { t } = useT()
  return (
    <section className="relative pt-32 sm:pt-40 pb-16 overflow-hidden">
      {/* Blue radial wash */}
      <div
        aria-hidden
        className="absolute inset-x-0 -top-40 h-[700px] pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at top, rgba(59,93,255,0.28), rgba(59,93,255,0.08) 40%, transparent 75%)',
        }}
      />

      {/* Animated grid (blue tint) */}
      <div className="absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_10%,transparent_70%)]">
        <AnimatedGridPattern
          numSquares={36}
          maxOpacity={0.12}
          duration={3}
          className="text-accent-500"
        />
      </div>

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="flex justify-center"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs text-accent-800">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-accent-500 opacity-60 animate-ping" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            <span className="font-medium">{t('blog.badgeName')}</span>
            <span className="text-accent-400">·</span>
            <span className="text-accent-700">{t('blog.badgeTopic')}</span>
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 text-center font-semibold tracking-[-0.03em] text-ink-950 text-[clamp(2.5rem,6vw,4.75rem)] leading-[1.02]"
        >
          {t('blog.heroTitleLine1')}
          <br />
          <span className="relative inline-block">
            <span className="font-semibold bg-gradient-to-r from-accent-600 via-accent-500 to-accent-700 bg-clip-text text-transparent">
              {t('blog.heroTitleHighlight')}
            </span>
            <motion.span
              initial={{ scaleX: 0, originX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="absolute left-0 right-0 -bottom-2 h-[3px] bg-gradient-to-r from-accent-600 to-accent-400 rounded-full"
            />
          </span>
          .
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-6 text-center text-ink-600 max-w-2xl mx-auto text-lg leading-relaxed"
        >
          {t('blog.heroSubtitle')}
        </motion.p>
      </div>
    </section>
  )
}
